import axios from "axios";

const UseBase = () => {
  const instance = axios.create({
    baseURL: "https://api.themoviedb.org/3/movie/",
  });

  return {
    instance,
  };
};

export default UseBase;
